export const PERMISSIONS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'invite_users', label: 'Invite Users' },
  { key: 'leads', label: 'Leads' },
  { key: 'customer_master', label: 'Customer Master' },
  { key: 'user_report', label: 'User Reports' },
  { key: 'leads_report', label: 'Leads Reports' },
  { key: 'interested_user', label: 'Category Interested Users' },
  { key: 'subscription', label: 'Subscription Plans' },
  { key: 'category', label: 'Category' },
  { key: 'role', label: 'Role' },
  { key: 'payment', label: 'Payment Report' }

];